import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import useProfileForm from '../hooks/Users/useProfileForm';
import { tokenStorage } from '../utils/encryptedCookie';

const UserPreferencesContext = createContext();

export const UserPreferencesProvider = ({ children }) => {
  const [bgColor, setBgColor] = useState('#2c3e50');
  const [textColor, setTextColor] = useState('#ffffff');
  const { fetchUserData, savePreferences } = useProfileForm();

  const loadPreferences = useCallback(async () => {
    try {
      const userData = await fetchUserData();
      if (userData) {
        setBgColor(userData.bgColor || '#2c3e50');
        setTextColor(userData.textColor || '#ffffff');
      }
    } catch (error) {
      // Ignora erros relacionados a username não encontrado ou quando não há usuário logado
      const errorMessage = error.message || '';
      if (errorMessage.includes('Username não encontrado') || 
          errorMessage.includes('Erro ao buscar dados do usuário')) {
        // Silencioso - é esperado quando não há usuário logado ou token ainda não carregado
        return;
      }
      // Só loga erros reais da API
      console.error('Erro ao buscar dados do usuário:', error);
    }
  }, [fetchUserData]);

  useEffect(() => {
    // Só tenta carregar se houver token (usuário logado)
    const token = tokenStorage.get();
    if (token) {
      loadPreferences();
    }
  }, [loadPreferences]);

  return (
    <UserPreferencesContext.Provider
      value={{
        bgColor,
        textColor,
        setBgColor,
        setTextColor,
        savePreferences,
        loadPreferences,
      }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
};

export const useUserPreferences = () => useContext(UserPreferencesContext);